import { KeyboardArrowUpRounded, KeyboardArrowDownRounded } from '@mui/icons-material';
import { Button, Menu, MenuItem } from '@mui/material';
import { Box } from '@mui/system';
import { FunctionComponent, ReactElement, ReactNode, useState } from 'react';

interface DropdownButtonMenuItem {
	label: ReactNode;
	onClick: () => void;
}

interface DropdownButtonProps {
	label: string;
	items: DropdownButtonMenuItem[];
}

const DropdownButton: FunctionComponent<DropdownButtonProps> = ({ label, items }): ReactElement => {
	const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);

	const menuOpen = Boolean(anchorElement);
	const buttonIcon = menuOpen ? <KeyboardArrowUpRounded /> : <KeyboardArrowDownRounded />;

	const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) =>
		setAnchorElement(event.currentTarget);
	const handleClose = () => setAnchorElement(null);

	return (
		<Box component="div">
			<Button variant="outlined" endIcon={buttonIcon} size="large" onClick={handleOpen}>
				{label}
			</Button>
			<Menu open={menuOpen} anchorEl={anchorElement} onClose={handleClose}>
				{items.map((item, key) => (
					<MenuItem
						key={key}
						onClick={() => {
							handleClose();
							item.onClick();
						}}
					>
						{item.label}
					</MenuItem>
				))}
			</Menu>
		</Box>
	);
};

export default DropdownButton;
